export default __webpack_public_path__ + "static/media/ic_payment.6234c6d9.svg";